/**
 * Final-evaluation retry screen.
 */
import React from "react";
import { useTranslation } from 'react-i18next';

import { VButton } from "form";

/**
 * Prompts a retry after a failed final exam.
 *
 * @param {{ onRestart?: Function }} props
 */
const FinalRetry = (props) => {

  const { totalCount, successCount, onRestartClick } = props;

  const { t } = useTranslation('common');

  return <>
    <div className="w-full">
      <div className="flex items-center flex-col shadow mt-5 p-4">
        <img className="w-20 h-20" src="https://files.plateformedoctonet.com/app-eduforma/sadicon-removebg-preview.png" alt="" />
        <p className="font-bold fsp-18 text-muted mt-4">
          {t("Oh no! You didn't make it this time. The good news is that you've earned the badge!")}
        </p>
        <p className="text-base">
          {t('Your score')}:&nbsp;
          {successCount}&nbsp;
          {successCount > 1 ? t('correct answers and') : t('correct answer and')}
          &nbsp;
          {totalCount - successCount}&nbsp;
          {totalCount - successCount > 1 ? t('incorrect answers') : t('incorrect answer')}
        </p>
        <VButton onClick={onRestartClick} variant="contained">
          {t('Repeat the quiz')}
        </VButton>
      </div>

    </div>
  </>;
};

export default FinalRetry;